import React, {useState} from 'react';
import { Container, Grid, Card, CardMedia, CardContent, Typography, Button, Select, MenuItem, IconButton, Box } from '@mui/material';
import { Link,useNavigate } from 'react-router-dom';
import axiosInstance from '../common/axios';
import AddToCartButton from '../components/AddToCartButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import ProductViewReview from '../pages/ProductViewReview';
import { normalizeKey } from '../i18n';

const Deals = ({ products }) => {
      const navigate = useNavigate();
  //  var [products, setProducts] = useState(p);
    const { t } = useTranslation(); // i18n hook
  var [product, setProduct] = useState(null);
    const [selectedVariants, setSelectedVariants] = useState({});
 const [currentImageIndex, setCurrentImageIndex] = useState({});
const [selectedProduct, setSelectedProduct] = useState(null);
  // Function to get the price, considering variant adjustments
  const getProductPrice = (product, variant) => {
    // If a variant is selected and has a price adjustment, apply it.
    if (variant && variant.price !== undefined) {
      return variant.price;
    }
    // Otherwise, return the base product price.
    return product.basePrice;
  };
  
  const getApplicableDiscount = (product, variant) => {
    // Get the base price of the product, including any variant adjustment
    const basePrice = getProductPrice(product, variant);
    let discount = null;

    // First, check for a discount on the variant
    if (variant && variant.discount) {
      discount = variant.discount;
    } 
    // If no variant discount, check for a shared discount on the product
    else if (product.sharedDiscount) {
      discount = product.sharedDiscount;
    }
    
    // Calculate the discount amount based on the determined discount
    if (discount) {
      if (discount.type === 'PERCENTAGE') {
        return {
          type: 'PERCENTAGE',
          amount: basePrice * (discount.percentage/100),
          percent: discount.percentage
        };
      } else if (discount.type === 'FIXED_AMOUNT') {
        return {
          type: 'FIXED_AMOUNT',
          amount: discount.amount,
           percent: 0
        };
      }
    }
    
    // Return a default object if no discount applies
    return {
      type: null,
      amount: 0,
       percent: 0
    };
  };

  // Function to handle variant selection change
  const handleVariantChange = (product, variant) => {
    setSelectedVariants(prevState => ({
      ...prevState,
      [product.productId]: variant,
    }));
    // When a variant is selected, reset the image to the variant's image
    // Find the index of the selected variant's image within the full image list
    const allImages = [product.imageUrl, ...product.variants.map(v => v.imageUrl)];
    const newIndex = allImages.findIndex(img => img === variant.imageUrl);
    setCurrentImageIndex(prevState => ({
      ...prevState,
      [product.productId]: newIndex !== -1 ? newIndex : 0,
    }));
  };

  // Function to handle image navigation
  const handleImageNav = (productId, direction, imageCount) => {
    setCurrentImageIndex(prevState => {
      const currentIndex = prevState[productId] !== undefined ? prevState[productId] : 0;
      let newIndex;
      if (direction === 'next') {
        newIndex = (currentIndex + 1) % imageCount;
      } else {
        newIndex = (currentIndex - 1 + imageCount) % imageCount;
      }
      return { ...prevState, [productId]: newIndex };
    });
  };
  
    const handleStarClick = (product) => {
    // Navigate to ProductDetails page with productId
   // navigate(`/product/${productId}`);
      
      console.log("selceted : " + product.productId);
        setSelectedProduct(product);
  };
  
const DEFAULT_IMAGE = "/images/no_image.png";
const handleImageError = (e) => {
    // Prevents infinite loop if the dummy image itself is missing
    e.target.onerror = null; 
    e.target.src = DEFAULT_IMAGE;
  };
  
  return (
  <Container disableGutters // Helps prevent double padding on mobile
  maxWidth="lg" 
  sx={{ 
    pb: 5, 
    pt: 2, 
    px: { xs: 2, sm: 3 } 
  }}>
      <Typography variant="h4" gutterBottom sx={{ fontSize: { xs: '1.5rem', md: '2.125rem' } }}>
       {t('products' , 'Products')}
      </Typography>
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }} // Smaller spacing for mobile
    sx={{ width: '100%', margin: 0 }}>
      {Array.isArray(products) && products.length > 0 ? (
    
        products.map((product) => {
        const currentVariant = selectedVariants[product.productId] ?? product.variants[0];
          // Determine the final price to display
          const displayPrice = getProductPrice(product, currentVariant);
          const discountDetails = getApplicableDiscount(product, currentVariant);
          
          // Create a single array of all possible images for the slider
          const allImages = [product.imageUrl, ...product.variants.map(v => v.imageUrl)].filter(Boolean);
          const currentImage = allImages[currentImageIndex[product.productId] || 0];

          return (
             <Grid item key={product.productId} xs={6} sm={4} md={3} lg={3}> 
               <Card   sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
                <CardMedia
                  component="img"
                  alt={product.productName}
                   sx={{
                    height: { xs: 140, sm: 180, md: 220 },
                    objectFit: 'contain',
                      width: '100%'
                  }}
                  image={`../images/${currentImage}`}
                  onError={handleImageError}
                />
                {allImages.length > 1 && (
                  <>
                    <IconButton
                      onClick={() => handleImageNav(product.productId, 'prev', allImages.length)}
                      style={{ position: 'absolute', left: 5, top: '50%', transform: 'translateY(-50%)', backgroundColor: 'rgba(255, 255, 255, 0.7)', padding: '4px' }}
                      size="small"
                    >
                      <ArrowBackIosIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      onClick={() => handleImageNav(product.productId, 'next', allImages.length)}
                      style={{ position: 'absolute', right: 5, top: '50%', transform: 'translateY(-50%)', backgroundColor: 'rgba(255, 255, 255, 0.7)', padding: '4px' }}
                      size="small"
                    >
                      <ArrowForwardIosIcon fontSize="small" />
                    </IconButton>
                  </>
                )}
              <CardContent sx={{ p: { xs: 1, sm: 2 }, flexGrow: 1 }}>
                <Typography gutterBottom variant="h6" sx={{ fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.25rem' } }}>
                   {t(normalizeKey(product.productName), product.productName)}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
                  {product.description}
                </Typography>
                <Typography variant="subtitle1" color="primary">
                   {discountDetails.amount > 0 ? (
                   <>
                    <Typography variant="subtitle2"  style={{ textDecoration: 'line-through' }}>
                      ₹{displayPrice}
                     </Typography>
                     <Typography variant="subtitle1">
                    ₹{(displayPrice - discountDetails.amount).toFixed(2) }
                  </Typography>
                      <span style={{ marginLeft: '8px', color: 'green' }}>
                        {discountDetails.type === 'PERCENTAGE' ? `(${discountDetails.percent}% OFF, saving ₹${discountDetails.amount.toFixed(2)})` : `(Saving ₹${discountDetails.amount.toFixed(2)})`}
                      </span>
                      </>
                    ) : (
                    <>
                    <Typography variant="subtitle2">
                      ₹{displayPrice}
                     </Typography>
                     </>
                    )}
                    
                </Typography>
                      <div className="flex items-center mt-2" onClick={() => handleStarClick(product)} >
       {Array.from({ length: 5 }).map((_, index) =>
  index < Math.round(product.averageRating) ? (
    <StarIcon key={index} style={{ color: "#facc15" , fontSize: '1rem'}} /> // yellow
  ) : (
    <StarBorderIcon key={index} style={{ color: "#d1d5db", fontSize: '1rem' }} /> // gray
  )
)}
<span className="ml-2 text-sm text-gray-600"> {product.averageRating?.toFixed(1)}  / 5</span>
      </div>
                  <Select
                    fullWidth // Ensures the dropdown doesn't expand past the card
                    size="small"
                    value={currentVariant?.variantId || product.variants[0]?.variantId || ''}
                    onChange={(e) => {
                      const variantId = e.target.value;
                      const variant = product.variants.find(v => v.variantId === variantId);
                      handleVariantChange(product, variant);
                    }}
                    sx={{ mt: 1, fontSize: '0.8rem' }}
                  >
                    {product.variants.map((variant) => (
                      <MenuItem key={variant.variantId} value={variant.variantId}>
                        {t(normalizeKey(variant.variantName) , variant.variantName)} - {t(normalizeKey(variant.color), variant.color)} {variant.size && `(${variant.size})`}
                      </MenuItem>
                    ))}
                  </Select>
<Box sx={{ mt: 'auto', pt: 1 }}>
               <AddToCartButton product={product} selectedVariant={currentVariant || product.variants[0]} />
               </Box>
              </CardContent>
            </Card>
          </Grid>
          );
        })
       ) : (
        <Typography variant="body1" color="textSecondary" sx={{ ml: 2 }}>
          No products available
        </Typography>
      )}
            </Grid>
 {selectedProduct && (
  <ProductViewReview 
    product={selectedProduct} 
    onClose={() => setSelectedProduct(null)} 
  />
)}
    </Container>
  );
};

export default Deals;
